import * as THREE from "three";

export function createPlaneMaterial(
    noiseTexture: THREE.Texture,
    size: [number, number],
    position: [number, number, number],
) {
    const material = new THREE.MeshStandardMaterial({
        side: THREE.DoubleSide,
    });

    material.onBeforeCompile = (shader) => {
        shader.uniforms.noiseMap = { value: noiseTexture };
        shader.uniforms.planeSize = {
            value: new THREE.Vector2(size[0], size[1]),
        };
        shader.uniforms.planePosition = {
            value: new THREE.Vector3(position[0], position[1], position[2]),
        };

        ////////// VERTEX //////////
        shader.vertexShader = shader.vertexShader.replace(
            "#include <common>",
            `
            #include <common>
            uniform vec2 planeSize;
            uniform vec3 planePosition;
            varying vec3 vWorldPos;
            varying vec2 vUv;
            varying vec2 vNoiseUv;
            `,
        );

        shader.vertexShader = shader.vertexShader.replace(
            "#include <begin_vertex>",
            `
            #include <begin_vertex>
            vWorldPos = (modelMatrix * vec4(transformed, 1.0)).xyz;
            vUv = uv;

            vec3 localPos = vWorldPos - planePosition;
            vNoiseUv = (localPos.xz + planeSize * 0.5) / planeSize;
            `,
        );

        ////////// FRAGMENT //////////
        shader.fragmentShader = shader.fragmentShader.replace(
            "#include <common>",
            `
            #include <common>
            uniform sampler2D noiseMap;
            varying vec3 vWorldPos;
            varying vec2 vUv;
            varying vec2 vNoiseUv;
            `,
        );

        shader.fragmentShader = shader.fragmentShader.replace(
            "#include <color_fragment>",
            `
            #include <color_fragment>
            

            vec3 c1 = vec3(0.25, 0.6662, 0.118);
            vec3 c2 = vec3(0.357, 0.761, 0.153);
            vec3 c3 = vec3(0.507, 0.83, 0.170);


            vec4 noise = texture2D(noiseMap, vNoiseUv);
            
            vec3 finalColor = c3;
            finalColor = mix(finalColor, c2, smoothstep(0.47, 0.47, noise.r));
            finalColor = mix(finalColor, c1, smoothstep(0.53, 0.53, noise.b));
            
            diffuseColor.rgb = finalColor;
            `,
        );
    };

    return material;
}
